import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Buffer } from "buffer";
import Loading from '../loading';

const ViewDoc = ({ currentDoc, setCurrentDoc }) => {

    const [loading, setLoading] = useState(true);

    if (loading && currentDoc.show && !currentDoc.noBuffer) {
        Buffer.from(currentDoc.data.file.data);
        setLoading(false);
    }

    const handleClose = () => setCurrentDoc({ ...currentDoc, show: false });

    return (
        <Dialog
            fullScreen
            open={currentDoc.show}
            onClose={handleClose}
        >
            <DialogTitle sx={{ bgcolor: '#282c34', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                Doc
                <IconButton onClick={handleClose} sx={{ color: 'white' }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                {(!loading && currentDoc.show) ? (
                    <iframe
                        title={currentDoc.data.fileName}
                        width="100%"
                        height="700"
                        frameBorder="0"
                        src={`https://docs.google.com/gview?url=${`${process.env.REACT_APP_SOCKET_URL}/file/${currentDoc.data.fileName}`}&embedded=true`}
                    />
                ) : (
                    <Loading />
                )}
            </DialogContent>
        </Dialog>
    )
};

export default ViewDoc;
